import "./less/iPortfolio.scss";

import ReactDOM from "react-dom/client";
import App from "./App";
import PathProvider from "./libs/path/PathProvider";
import { PortfolioProvider } from "./hooks/PortfolioProvider";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import PortAccount from "./models/PortAccount";
import AuthProvider from "./gui/Login/AuthProvider";
import OverlayProvider from "./gui/Overlay/OverlayProvider";
import SnackbarProvider from "./gui/Snackbar/SnackbarProvider";
import LoginProvider from "./gui/Login/LoginProvider";
import {DateRangeFilterProvider} from "./portlibs/DateRangeFilterProvider"
import PortFilterProvider from "./hooks/PortFilter";

(async function main(){
  const root = ReactDOM.createRoot(document.getElementById("root")!);

  await PortAccount.i.init().auth()

  root.render(<PathProvider><AuthProvider api={PortAccount.i}><PortfolioProvider>
      <PortFilterProvider>
        <SnackbarProvider><OverlayProvider>
        <LoginProvider api={PortAccount.i} required={true}>
          <DateRangeFilterProvider>
            <App/>
          </DateRangeFilterProvider>
        </LoginProvider>
        </OverlayProvider></SnackbarProvider>
      </PortFilterProvider>
    </PortfolioProvider></AuthProvider></PathProvider>);

  serviceWorkerRegistration.register()
})()
